import * as Bluebird from "bluebird";
import h from "../helper/helper";
var afterHooks = [];
var Observer = /** @class */ (function () {
    function Observer() {
        this._listeners = {};
        this._listenersOnce = {};
    }
    Observer.addAfterHook = function (listener) {
        afterHooks.push(listener);
    };
    ;
    Observer.prototype.listenOnce = function (fn, type) {
        type = type || "any";
        if (typeof this._listenersOnce[type] === "undefined") {
            this._listenersOnce[type] = [];
        }
        this._listenersOnce[type].push(fn);
    };
    Observer.prototype.listenPromise = function (type) {
        var that = this;
        return new Bluebird(function (resolve) {
            that.listenOnce(resolve, type);
        });
    };
    Observer.prototype.listen = function (fn, type) {
        type = type || "any";
        if (typeof this._listeners[type] === "undefined") {
            this._listeners[type] = [];
        }
        this._listeners[type].push(fn);
    };
    Observer.prototype.notify = function (data, type, returnF) {
        type = type || "any";
        if (!returnF) {
            returnF = function () { };
        }
        var listeners = this._listeners[type] || [];
        var listenersOnce = this._listenersOnce[type] || [];
        var subscribers = (listeners).concat(listenersOnce);
        this._listenersOnce[type] = [];
        var result = h.callEach(subscribers, [data], returnF);
        if (type !== "any") {
            result = returnF(this.notify(data), result);
        }
        h.callEach(afterHooks);
        return result;
    };
    Observer.extend = function (obj) {
        var internalObserver = new Observer();
        obj.notify = internalObserver.notify.bind(internalObserver);
        obj.listenOnce = internalObserver.listenOnce.bind(internalObserver);
        obj.listenPromise = internalObserver.listenPromise.bind(internalObserver);
        obj.listen = internalObserver.listen.bind(internalObserver);
    };
    return Observer;
}());
export default Observer;
export var extend = function (obj) {
    Observer.extend(obj);
};



//////////////////
// WEBPACK FOOTER
// ./js/asset/observer.ts
// module id = SiYL
// module chunks = 1 2 3 4 5 6